<div
  class="cads-menu-row"
  [class.cads-menu-row--tappable]="_isTappable()"
  [attr.role]="_isTappable() ? 'button' : null"
  [attr.tabindex]="_isTappable() ? 0 : null"
  (click)="_onActivate()"
  (keydown)="_onKeydown($event)"
  (keyup)="_onKeyup($event)"
>
  <ng-content />
</div>
